import React, { ChangeEvent, useRef } from 'react';
import { Form } from 'react-bootstrap';
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
} from 'react-hook-form';
import { InputContainer } from './styles';

interface InputMesAnoProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  nameMes: string;
  nameAno: string;
  register: UseFormRegister<FieldValues>;
  isErrorMes: boolean;
  isErrorAno: boolean;
  maxLengthMes: number;
  maxLengthAno: number;
  maxAno: number;
  minAno?: number;
  step?: string;
  showIcon?: boolean;
  control?: Control<FieldValues, any>;
}

export const InputMesAno: React.FC<InputMesAnoProps> = ({
  label = 'Mes/Ano',
  nameMes,
  nameAno,
  register,
  isErrorMes,
  isErrorAno,
  maxLengthAno,
  maxLengthMes,
  step = '1',
  maxAno = 99999999,
  minAno = -99999999,
  control,
  ...rest
}) => {
  const handleKeyDown = (event: any) => {
    if ([69, 109, 107, 194, 110].includes(event.keyCode)) {
      event.preventDefault();
    }
  };

  const handleMesChange = (
    onChange: (value: string) => void,
    inputValue: string,
  ) => {
    if (inputValue.length === 2) {
      const month = parseInt(inputValue, 10);
      if (!Number.isNaN(month) && month >= 1 && month <= 12) {
        onChange(inputValue);
      } else {
        onChange('');
      }
    } else if (inputValue.length > maxLengthMes) {
      onChange(inputValue.slice(0, maxLengthMes));
    } else {
      onChange(inputValue);
    }
  };

  const handleAnoChange = (
    onChange: (value: string) => void,
    inputValue: string,
  ) => {
    const ano = new Date().getFullYear() - 1;
    if (inputValue.length === 4) {
      const year = parseInt(inputValue, 10);
      if (!Number.isNaN(year) && year >= ano) {
        onChange(inputValue);
      } else {
        onChange('');
      }
    } else if (inputValue.length > maxLengthAno) {
      onChange(inputValue.slice(0, maxLengthAno));
    } else {
      onChange(inputValue);
    }
  };

  return (
    <InputContainer>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <div className="d-flex align-items-center">
          <Controller
            name={nameMes}
            control={control}
            render={({ field: { value, onChange } }) => {
              return (
                <input
                  {...register(nameMes)}
                  type="number"
                  step={step}
                  className={
                    isErrorMes ? 'form-control is-invalid' : 'form-control'
                  }
                  placeholder="00"
                  max={12}
                  min={1}
                  onKeyDown={handleKeyDown}
                  maxLength={maxLengthMes}
                  value={value || ''}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    const inputValue = event.target.value;
                    handleMesChange(onChange, inputValue);
                  }}
                  {...rest}
                />
              );
            }}
          />
          <Controller
            name={nameAno}
            control={control}
            render={({ field: { value, onChange } }) => {
              return (
                <input
                  {...register(nameAno)}
                  type="number"
                  step={step}
                  className={
                    isErrorAno ? 'form-control is-invalid' : 'form-control'
                  }
                  style={{ marginLeft: '2px' }}
                  placeholder="00"
                  max={maxAno}
                  min={minAno}
                  onKeyDown={handleKeyDown}
                  maxLength={maxLengthAno}
                  value={value || ''}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    const inputValue = event.target.value;
                    handleAnoChange(onChange, inputValue);
                  }}
                  {...rest}
                />
              );
            }}
          />
        </div>
      </Form.Group>
    </InputContainer>
  );
};
